import i18n from '@/plugins/i18n';

export const getDocumentTableHeaders = (
  visibleDocumentStatus,
  hasCostCenter,
  showOrderNumber,
  showOrganization,
  visibleCostCenter,
  isIterableOrder,
  hasBriefbutler) => {
  return [
    {
      text: i18n.t('table.header.status'),
      value: 'validationStatus',
      align: 'center',
      width: 90,
      filter: (value) => {
        if (visibleDocumentStatus !== undefined) {
          // filter document by status
          return visibleDocumentStatus[value];
        } else {
          return true;
        }
      }
    },
    {
      text: i18n.t('table.header.parcel.number'),
      value: 'documentId',
      align: 'center',
      isHidden: true
    },
    {
      text: i18n.t('table.header.order.number'),
      value: 'orderNumber',
      isHidden: !showOrderNumber
    },
    {
      text: i18n.t('table.header.organization'),
      value: 'organizationId',
      isHidden: !showOrganization
    },
    {
      text: i18n.t('table.header.user'),
      value: 'owner.lastName',
      isHidden: false // Beispiel, passe die Logik an
    },
    {
      text: i18n.t('table.header.filename'),
      value: 'uploadFileName',
      width: 120,
      align: 'start'
    },
    {
      text:  i18n.t('table.header.merge.count'),
      value: 'mergeCount',
      isHidden: true
    },
    {
      text: i18n.t('table.header.receiver'),
      value: 'recipientInfo.recipient',
      align: 'start',
      width: 200,
    },
    // {
    //   text: i18n.t('table_carrier'),
    //   value: 'carrier',
    //   isHidden: !isIterableOrder
    // },
    {
      text: i18n.t('table.header.delivery.type'),
      value: 'deliveryType',
      isHidden: !isIterableOrder || !hasBriefbutler
    },
    {
      text: i18n.t('table.header.production.status'),
      value: 'productionStatus',
      isHidden: !isIterableOrder
    },
    {
      text: i18n.t('table.header.cost.center'),
      value: 'costCenter',
      isHidden: !hasCostCenter,
      filter: (value) => {
        if (visibleCostCenter !== undefined) {
          return visibleCostCenter.includes(value);
        } else {
          return true;
        }
      }
    },
    {
      text: i18n.t('table.header.actions'),
      value: 'actions',
      align: 'center',
      sortable: false,
      width: 260,
      filter: (value) => {
        if (visibleDocumentStatus !== undefined) {
          return visibleDocumentStatus[value];
        } else {
          return true;
        }
      }
    }
  ].filter((header) => {
    return !header.isHidden
  });
};
